"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.get"));
var _nodeVibrant = _interopRequireDefault(require("node-vibrant"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var Container = _styledComponents["default"].div.withConfig({
  displayName: "BackgroundCoverImage__Container",
  componentId: "sc-1qz80s2-0"
})(["bottom:0;left:0;position:absolute;right:0;top:0;img{filter:brightness(60%);height:100%;object-fit:cover;width:100%;}"]);
var Dimmer = _styledComponents["default"].div.withConfig({
  displayName: "BackgroundCoverImage__Dimmer",
  componentId: "sc-1qz80s2-1"
})(["bottom:0;left:0;opacity:0.82;position:absolute;right:0;transition:background-color 500ms ease-in;top:0;", ""], function (props) {
  return props.backgroundColor && (0, _styledComponents.css)(["background:", ";"], props.backgroundColor);
});
var BackgroundCoverImage = function BackgroundCoverImage(props) {
  var _React$useState = _react["default"].useState('#222'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    backgroundColor = _React$useState2[0],
    setBackgroundColor = _React$useState2[1];
  _nodeVibrant["default"].from(
  // contentful does blocks the network attempt
  // so base64 allows this component to do it in browser instead
  (0, _lodash["default"])(props, 'fluid.base64', (0, _lodash["default"])(props, 'fluid.src'))).getPalette(function (err, palette) {
    var bg = (0, _lodash["default"])(palette, 'DarkVibrant.hex');
    if (!err && bg) setBackgroundColor(bg);
  });
  return /*#__PURE__*/_react["default"].createElement(Container, {
    "aria-hidden": true
  }, /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], _extends({}, props, {
    style: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0
    }
  })), /*#__PURE__*/_react["default"].createElement(Dimmer, {
    backgroundColor: backgroundColor
  }));
};
BackgroundCoverImage.propTypes = {
  fluid: _propTypes["default"].shape({
    src: _propTypes["default"].string
  }),
  alt: _propTypes["default"].string
};
BackgroundCoverImage.defaultProps = {
  fluid: {
    src: 'https://source.unsplash.com/collection/388793/1600x900'
  },
  alt: 'Random photo selected from unsplash API'
};
var _default = BackgroundCoverImage;
exports["default"] = _default;